import { format } from 'date-fns';
import { Text } from 'recharts';

const CustomizedXAxisTick = ({ x, y, payload }) => {
  function formatDateSecondary(text) {
    const date = new Date(text);
    return format(date, 'HH:mm');
  }

  return (
    <Text
      fontSize={14}
      fontStyle="normal"
      textTransform="capitalize"
      x={x}
      y={y}
      width={75}
      fill="#818181"
      textAnchor="middle"
      verticalAnchor="start"
      dy={10}
    >
      {formatDateSecondary(payload.value)}
    </Text>
  );
};

export default CustomizedXAxisTick;
